import {gsap} from "gsap";
import {NineToFive} from "../NineToFive";

export class WinWays extends PIXI.Container {
    private ways:number;
    private style:PIXI.TextStyle;
    private actualText:PIXI.Text;
    private fadeDuration:number;


    constructor() {
        super();
        this.fadeDuration = 0.1;
        this.ways = 0;
        this.style = new PIXI.TextStyle({
            fill: "#FFFF00",
            fontFamily: "Helvetica",
            fontSize: 30,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8
        });
        this.actualText = new PIXI.Text(this.formattedText(), this.style);
        this.actualText.alpha = 0;
        this.actualText.anchor.set(0.5, 0.5);
        this.addChild(this.actualText);
    }

    private formattedText():string {
       return this.ways > 1
              ? `${this.ways} ${NineToFive.apiPlugin.translations.translate("Ways Won")}`
              : `1 ${NineToFive.apiPlugin.translations.translate("Way Won")}`;
    }

    private setWays(ways:number):void {
        this.ways = ways;
        this.actualText.text = this.formattedText();
    }

    public show(ways:number): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {this.setWays(ways)})
            .add(gsap.to(this.actualText, {alpha: 1, duration: this.fadeDuration}))
    }

    public hide(): gsap.core.Timeline {
        return gsap.timeline().add(gsap.to(this.actualText, {alpha: 0, duration: this.fadeDuration}))
    }
}
